import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    meta:{tab:-1},
    component: login
  },
  { //注册
    path: '/register',
    name: 'register',
    meta:{tab:-1},
    component: () => import('../views/register/index.vue')
  },
  { //首页
    path: '/',
    name: 'home',
    meta:{tab:0},
    component: () => import('../views/home.vue')
  },
  { //标的
    path: '/lots',
    name: 'lots',
    meta:{tab:1},
    component: () => import('../views/lots.vue')
  },
  {  //拍卖会
    path: '/meeting',
    name: 'meeting',
    meta:{tab:2},
    component: () => import('../views/meeting.vue')
  },{  
    path: '/zhongtiezhuanqu',
    name: 'zhongtiezhuanqu',
    meta:{tab:1},
    component: () => import('../views/zhongtiezhuanqu.vue')
  },
  {//铁建专区
    path: '/tiejianzhuanqu',
    name: 'tiejianzhuanqu',
    meta:{tab:1},
    component: () => import('../views/tiejianzhuanqu.vue')
  },
  { //租赁列表
    path: '/lease',
    name: 'lease',
    meta:{tab:4},
    component: () => import('../views/lease/index.vue')
  },
  {  //标的目录 
    path: '/meetingLotsList',
    name: 'meetingLotsList',
    meta:{tab:2},
    component: () => import('../views/meetingLotsList.vue')
  },
  { //拍卖大厅 标的详情展示
    path: '/lotDetail',
    name: 'lotDetail',
    meta:{tab:1},
    component: () => import('../views/lotDetail/index.vue')
  },
  { //拍卖师进入 标的详情展示
    path: '/auctioneer',
    name: 'auctioneer',
    meta:{tab:1},
    component: () => import('../views/auctioneer/index.vue')
  },
  
  { //拍卖公告
    path: '/notice',
    name: 'notice',
    meta:{tab:3},
    component: () => import('../views/notice.vue')
  }, 
  { //拍卖公告详情
    path: '/noticecont',
    name: 'noticecont',
    meta:{tab:3},
    component: () => import('../views/noticecont.vue')
  }, 
  { //我的
    path: '/my',
    name: 'my',
    meta:{tab:0,token:true},
    component: () => import('../views/my/index.vue')
  }, 
  { //我的
    path: '/help',
    name: 'help',
    meta:{tab:0,token:true},
    component: () => import('../views/help/index.vue')
  },
  { //新闻列表
    path: '/news',
    name: 'news',
    meta:{tab:0},
    component: () => import('../views/news.vue')
  },
  
  { //新闻详情
    path: '/htmldetail',
    name: 'htmldetail',
    meta:{tab:4},
    component: () => import('../views/lease/htmldetail.vue')
  },
]

const router = new VueRouter({
  mode: "history",
  base: '/',
  routes
})

export default router
